import "UI/Widget/Base";
import "UI/Plugin/Draggable";
import "System/NumSeq";
NS("UI.Widget");

UI.Widget.Form = Class(UI.Widget.Base, {
    template: "UI/Widget/Form/Form",
    formTemplate: null,
    formOptions: null,

    title: "",

    showTitle: true,
    showCloseBtn: true,

    $body: null,
    $header: null,
    $form: null,

    draggable: false,
    switchable: true,

    initialize: function(parent, options) {
        this.formOptions = options;

        this.Parent(parent, options);

        GLOBAL.FORM = this;
    },

    destroy: function() {
        this.$body = null;
        this.$header = null;
        this.$form = null;

        return this.ParentCall();
    },

    setTitle: function(title) {
        this.title = title;

        this.$name("form-title").text(this.getTitle());

        this.emit("title", {
            title: this.getTitle()
        });

        return this;
    },

    getTitle: function() {
        if (Util.isFunction(this.title)) {
            return this.title();
        } else {
            return this.title;
        }
    },

    render: function() {
        var self = this;

        this.ParentCall();

        this.$header = this.$name("form-header");
        this.$body = this.$name("form-body");
        this.initialiseCollapsingSections();

        if (this.draggable) {
            this.use(UI.Plugin.Draggable, {
                handle: this.showTitle ? this.$header : this.$element
            });
        }

        this.renderForm();

        if (this.switchable) {
            UI.Widget.Form.registerSwitchable(this);

            this.$element.on("mousedown", function(e) {
                // first call of popSwitchable travers up all parent forms
                if (!e.originalEvent.switchableHandled) {
                    UI.Widget.Form.popSwitchable(self);
                }
                e.originalEvent.switchableHandled = true;
            });
        }

        return this;
    },
    renderContainer: function() {
        return this;
    },
    renderForm: function() {
        if (this.formTemplate) {
            if (this.$form) {
                this.$form.empty();
            }

            this.$form = UI.Template.$render(this.formTemplate, {
                widget: this
            }).appendTo(this.$body);
        }
    },

    remove: function() {
        this.ParentCall();

        UI.Widget.Form.unregisterSwitchable(this);
    },

    pop: function() {
        if (this.switchable) {
            UI.Widget.Form.popSwitchable(this);
        }
    },

    onCloseClick: function() {
        this.close();
    },
    /**
     * @fires UI.Widget.Form#close
     */
    close: function() {
        if (this.isDestroyed) {
            return;
        }

        this.emit("close");

        this.destroy();
    },

    initialiseCollapsingSections: function() {
        $(this.$body).on('click', '.collapsing-section .title', function() {
            $(this).parent().toggleClass('collapsed');
        });
    }
});

UI.Widget.Form.Static({
    switchableForms: [],
    switchableZIndex: 1,
    switchableATopZIndex: 100,
    switchableRoundIndex: 0,
    switchableItems: [],
    switchableParent: null,
    switchableItemsContainer: null,

    registerSwitchable: function(form) {
        if (!~this.switchableForms.indexOf(form)) {
            this.switchableForms.push(form);

            this.emit("Switchable.Register", {
                widget: form
            });
            this.updateSwitchableZIndex();

            if (form.CLASS_NAME) {
                form.switchableId = System.NumSeq.next("switchableId");

                this.switchableItems.push({
                    id: form.switchableId,
                    form: form.CLASS_NAME,
                    options: Util.clone(form.formOptions)
                });

                this.updateSwitchableHash();
            }
        }
    },

    unregisterSwitchable: function(form) {
        var index = this.switchableForms.indexOf(form);

        if (~index) {
            this.switchableForms.splice(index, 1);

            this.emit("Switchable.Unregister", {
                widget: form
            });
            this.updateSwitchableZIndex();

            if (form.switchableId) {
                for (var i = 0; i < this.switchableItems.length; i++) {
                    if (this.switchableItems[i].id == form.switchableId) {
                        this.switchableItems.splice(i, 1);
                        this.updateSwitchableHash();
                        break;
                    }
                }
            }
        }
    },

    updateSwitchableHash: function() {
        window.location.hash = encodeURIComponent(JSON.stringify(this.switchableItems));
    },

    restoreSwitchableItems: function() {
        var self = this;
        var hash = window.location.hash;

        if (hash && this.switchableParent && this.switchableItemsContainer) {
            try {
                var items = JSON.parse(decodeURIComponent(hash.substr(1)));

                if (Util.isArray(items)) {
                    for (var i = 0; i < items.length; i++) {
                        var item = items[i];

                        (function(item) {
                            var form = Util.create(item.form, [self.switchableParent, item.options]);

                            form.switchableId = item.id;

                            form.render().appendTo(self.switchableItemsContainer);
                        })(item);
                    }
                }
            } catch (e) {}
        }
    },

    popSwitchable: function(form) {
        if (form.parent && form.parent.switchable) {
            this.popSwitchable(form.parent);
        }

        var index = this.switchableForms.indexOf(form);

        if (~index) {
            this.switchableForms.splice(index, 1);
            this.switchableForms.push(form);
            this.updateSwitchableZIndex();
        }
    },

    popSwitchablePrev: function() {
        var length = this.switchableForms.length;

        if (length > 1) {
            this.popSwitchable(this.switchableForms[length - 2]);
        }
    },

    popSwitchableRound: function() {
        var self = this;

        function swap(index, force) {
            var tmp;
            var length = self.switchableForms.length;

            if ((index || force) && index < self.switchableForms.length) {
                tmp = self.switchableForms[length - 1];

                self.switchableForms[length - 1] = self.switchableForms[length - index - 1];
                self.switchableForms[length - index - 1] = tmp;
            }
        }

        swap(this.switchableRoundIndex);

        this.switchableRoundIndex++;

        if (this.switchableRoundIndex >= this.switchableForms.length) {
            this.switchableRoundIndex = 0;
        }

        swap(this.switchableRoundIndex, true);

        this.updateSwitchableZIndex();
    },

    resetSwitchableRound: function() {
        var self = this;
        var length = this.switchableForms.length;

        function swap(index) {
            var tmp;
            var length = self.switchableForms.length;

            if (index && index < self.switchableForms.length) {
                tmp = self.switchableForms[length - 2];

                self.switchableForms[length - 2] = self.switchableForms[length - index - 1];
                self.switchableForms[length - index - 1] = tmp;
            }
        }

        if (this.switchableRoundIndex > 1) {
            if (length > 1) {
                swap(this.switchableRoundIndex);
            }
        }

        this.switchableRoundIndex = 0;

        this.updateSwitchableZIndex();
    },

    isOnTop: function(form) {
        var length = this.switchableForms.length;

        return length && form == this.switchableForms[length - 1];
    },

    getTop: function() {
        var length = this.switchableForms.length;

        return length ? this.switchableForms[length - 1] : null;
    },

    updateSwitchableZIndex: function() {
        for (var i = 0; i < this.switchableForms.length; i++) {
            if (this.switchableForms[i].$element) {
                var offset = this.switchableForms[i].alwaysOnTop ? this.switchableATopZIndex : this.switchableZIndex;
                this.switchableForms[i].$element.css("z-index", i + offset);
            }
        }

        if (this.switchableForms.length) {
            this.emit("Switchable.Pop", {
                widget: this.switchableForms[this.switchableForms.length - 1]
            });
        }
    },

});
